import styles from './CreditsTable.module.css'
import EditableRow from './EditableRow'

const CreditsTable = ({ editId, savingId, data, handleEdit, handleSave, handleCancel }) => {
  return (
    <table className={styles.table}>
      <thead>
        <tr className={styles.tableHeaderRow}>
          <th className={styles.th}>ID</th>
          <th className={styles.th}>Username</th>
          <th className={styles.th}>License Key</th>
          <th className={styles.th}>Available</th>
          <th className={styles.th}>Used</th>
          <th className={styles.th}>Status</th>
          <th className={styles.th}>Actions</th>
        </tr>
      </thead>
      <tbody>
        {data.map((row) =>
          editId === row.id ? (
            <EditableRow
              key={row.id}
              row={row}
              onSave={handleSave}
              onCancel={handleCancel}
              isSaving={savingId === row.id}
            />
          ) : (
            <tr className={styles.tableBodyRow} key={row.id}>
              <td className={styles.td}>{row.id}</td>
              <td className={styles.td}>{row.username}</td>
              <td className={styles.td}>{row.license_key}</td>
              <td className={styles.td}>{row.limit}</td>
              <td className={styles.td}>{row.used_license}</td>
              <td className={styles.td}>
                <span
                  className={`${styles.statusPill} ${
                    row.status.toLowerCase() === 'active' ? styles.statusActive : styles.statusInactive
                  }`}
                >
                  {row.status}
                </span>
              </td>
              <td className={styles.td}>
                <button className={styles.editBtn} onClick={() => handleEdit(row.id)}>
                  Edit
                </button>
              </td>
            </tr>
          )
        )}
      </tbody>
    </table>
  )
}

export default CreditsTable
